import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
import random from './random.js';
import { p2s as concatSalt } from '../lib/buffer_utils.js';
import { encode as base64url } from './base64url.js';
import { wrap, unwrap } from './aeskw.js';
import checkP2s from '../lib/check_p2s.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';
function getCryptoKey(key, alg) {
  if (key instanceof Uint8Array) {
    return crypto.subtle.importKey('raw', key, 'PBKDF2', false, ['deriveBits']);
  }
  if (isCryptoKey(key)) {
    checkEncCryptoKey(key, alg, 'deriveBits', 'deriveKey');
    return key;
  }
  throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types), ['Uint8Array'])));
}
function deriveKey(_x, _x2, _x3, _x4) {
  return _deriveKey.apply(this, arguments);
}
function _deriveKey() {
  _deriveKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(p2s, alg, p2c, key) {
    var salt, keylen, subtleAlg, wrapAlg, cryptoKey;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            checkP2s(p2s);
            salt = concatSalt(alg, p2s);
            keylen = parseInt(alg.slice(13, 16), 10);
            subtleAlg = {
              hash: "SHA-".concat(alg.slice(8, 11)),
              iterations: p2c,
              name: 'PBKDF2',
              salt: salt
            };
            wrapAlg = {
              length: keylen,
              name: 'AES-KW'
            };
            _context3.next = 7;
            return getCryptoKey(key, alg);
          case 7:
            cryptoKey = _context3.sent;
            if (!cryptoKey.usages.includes('deriveBits')) {
              _context3.next = 14;
              break;
            }
            _context3.t0 = Uint8Array;
            _context3.next = 12;
            return crypto.subtle.deriveBits(subtleAlg, cryptoKey, keylen);
          case 12:
            _context3.t1 = _context3.sent;
            return _context3.abrupt("return", new _context3.t0(_context3.t1));
          case 14:
            if (!cryptoKey.usages.includes('deriveKey')) {
              _context3.next = 16;
              break;
            }
            return _context3.abrupt("return", crypto.subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, ['wrapKey', 'unwrapKey']));
          case 16:
            throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _deriveKey.apply(this, arguments);
}
export var encrypt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(alg, key, cek) {
    var p2c,
      p2s,
      derived,
      encryptedKey,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            p2c = _args.length > 3 && _args[3] !== undefined ? _args[3] : 2048;
            p2s = _args.length > 4 && _args[4] !== undefined ? _args[4] : random(new Uint8Array(16));
            _context.next = 4;
            return deriveKey(p2s, alg, p2c, key);
          case 4:
            derived = _context.sent;
            _context.next = 7;
            return wrap(alg.slice(-6), derived, cek);
          case 7:
            encryptedKey = _context.sent;
            return _context.abrupt("return", {
              encryptedKey: encryptedKey,
              p2c: p2c,
              p2s: base64url(p2s)
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function encrypt(_x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();
export var decrypt = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(alg, key, encryptedKey, p2c, p2s) {
    var derived;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return deriveKey(p2s, alg, p2c, key);
          case 2:
            derived = _context2.sent;
            return _context2.abrupt("return", unwrap(alg.slice(-6), derived, encryptedKey));
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function decrypt(_x8, _x9, _x10, _x11, _x12) {
    return _ref2.apply(this, arguments);
  };
}();